import React from 'react'
import PropTypes from 'prop-types'

import successSvg from '../../../../public/images/icons/alert-modal-success.svg'

const propTypes = {
  heading: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired
}

export const SuccessToast = ({ heading, body }) => (
  <div className="toast-alert__body">
    <img className="svg" src={successSvg} alt="success" />
    <h2>{heading}</h2>
    <p>{body}</p>
  </div>
)
SuccessToast.propTypes = propTypes
